import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import "./GestionOffers.css";
import OfferForm from "../OfferForm";

export default function GestionOffers() {
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [offerToUpdate, setOfferToUpdate] = useState(null);
    const [showFormOffer, setShowFormOffer] = useState(false);
    const apiUrl = process.env.REACT_APP_API_URL;
    const { token } = useSelector((state) => state.auth);

    const refreshOffers = useCallback(() => {
        const url = `${apiUrl}/api/offers`;
        setLoading(true);

        return fetch(url, { method: "GET" })
            .then((res) => res.json())
            .then((data) => setOffers(data))
            .catch((err) => console.error("Erreur chargement des offres :", err))
            .finally(() => setLoading(false));
    }, [apiUrl]);

    useEffect(() => {
        refreshOffers();
    }, [refreshOffers]);

    const handleDeleteOffer = (id) => {
        if (!window.confirm("Supprimer cette offre ?")) return;

        fetch(`${apiUrl}/api/offers/${id}`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => {
                if (!res.ok) throw new Error("Erreur suppression offre");
                return res.json();
            })
            .then(() => refreshOffers())
            .catch((err) => console.error(err));
    };

    return (
        <section className="secteur-section">
            <h2>Gestion des offres INTERESEAUX</h2>

            <button
                className="btn-add-secteur"
                onClick={() => {
                    setOfferToUpdate(null);
                    setShowFormOffer(true);
                }}
            >
                <FontAwesomeIcon icon={faPlus} /> AJOUTER UNE OFFRE
            </button>

            {loading ? (
                <div className="loader">
                    <div className="spinner"></div>
                    Chargement des offres...
                </div>
            ) : offers.length === 0 ? (
                <p>Aucune offre disponible.</p>
            ) : (
                offers.map((offer) => (
                    <div key={offer.idOffer} className="offer-card">
                        <div className="offer-info">
                            <span className="offer-title">{offer.titleOffer}</span>
                            <span className="offer-desc">{offer.descriptionOffer}</span>
                            <span className="offer-price">
                                {offer.priceOfferTTC.toFixed(2)} € TTC
                            </span>
                        </div>
                        <div className="offer-actions">
                            <button
                                className="btn-edit"
                                onClick={() => {
                                    setOfferToUpdate(offer);
                                    setShowFormOffer(true);
                                }}
                            >
                                <FontAwesomeIcon icon={faEdit} /> Modifier
                            </button>
                            <button
                                className="btn-delete"
                                onClick={() => handleDeleteOffer(offer.idOffer)}
                            >
                                <FontAwesomeIcon icon={faTrash} /> Supprimer
                            </button>
                        </div>
                    </div>
                ))
            )}

            {showFormOffer && (
                <OfferForm
                    offer={offerToUpdate}
                    onClose={() => setShowFormOffer(false)}
                    onSave={refreshOffers}
                    apiUrl={apiUrl}
                    token={token}
                />
            )}

        </section>
    );
}
